import { combineReducers } from "redux";
import { reducerMode } from "./stateMode";
import { getListEnum, getListReducer } from "./stateListUtils";

export const FetchStateCountries = getListEnum('COUNTRIES');
export const FetchStateOwners = getListEnum('OWNERS');
export const FetchStateReusables = getListEnum('REUSABLES');
export const FetchStateServices = getListEnum('SERVICES');
export const FetchStatePagesPages = getListEnum('PAGES_PAGES');
export const FetchStatePageCategories = getListEnum('PAGE_CATEGORIES');
export const FetchStateRoles = getListEnum('ROLES');
export const FetchStatePages = getListEnum('MENU_PAGES');
export const FetchStateProductCategories = getListEnum('PRODUCT_CATEGORIES');
export const FetchStateDownloadAuthors = getListEnum('DOWNLOAD_AUTHORS');
export const FetchStateDownloadTypes = getListEnum('DOWNLOAD_TYPES');

const rootPageReducer = combineReducers({
	pages: getListReducer(FetchStatePages),
	pageOwners: getListReducer(FetchStateOwners),
	pageReusable: getListReducer(FetchStateReusables),
	pageServices: getListReducer(FetchStateServices),
	pagePages: getListReducer(FetchStatePagesPages),
	pageCategories: getListReducer(FetchStatePageCategories),
	productCategories: getListReducer(FetchStateProductCategories),
	roles: getListReducer(FetchStateRoles),
	mode: reducerMode,
	countries: getListReducer(FetchStateCountries),
	downloadAuthors: getListReducer(FetchStateDownloadAuthors),
	downloadTypes: getListReducer(FetchStateDownloadTypes),
});

export default rootPageReducer;
